import { api } from "@/lib/orgApi";

export function isSurgicalHistoryWrite(url) {
  return /surgical-history/.test(String(url || ""));
}

export async function listSurgicalHistory(patientId) {
  if (!patientId) return { items: [], review: null, catalogs: null };
  const { data } = await api.get(`/patients/${encodeURIComponent(patientId)}/surgical-history`);
  return {
    items: data.items || [],
    review: data.review || null,
    catalogs: data.catalogs || null,
  };
}

export async function createSurgicalHistory(patientId, payload) {
  const { data } = await api.post(
    `/patients/${encodeURIComponent(patientId)}/surgical-history`,
    payload,
  );
  return data;
}

export async function updateSurgicalHistory(itemId, payload) {
  const { data } = await api.put(`/surgical-history/${encodeURIComponent(itemId)}`, payload);
  return data;
}

export async function removeSurgicalHistory(itemId) {
  const { data } = await api.delete(`/surgical-history/${encodeURIComponent(itemId)}`);
  return data;
}

export async function reviewSurgicalHistory(patientId) {
  const { data } = await api.post(
    `/patients/${encodeURIComponent(patientId)}/surgical-history/review`,
  );
  return data;
}

export async function getSurgicalHistoryCatalogs() {
  const { data } = await api.get("/surgical-history/catalogs");
  return data;
}
